import { reportStatsContractBreach } from '@/types/stats/statsContract.ts';

/**
 * Etykieta z rejestru albo zgłoszenie rozjazdu kontraktu. Klucz, którego
 * rejestr nie zna, nie jest danymi do pominięcia: na produkcji wchodzi na ekran
 * goły kod backendu, więc trzeba go zobaczyć w logu, a w rozwoju od razu.
 *
 * `subject` wchodzi do komunikatu w mianowniku („metryka lejka”) — to jedyne,
 * co odróżnia zgłoszenia czterech rejestrów ekranu wyjazdu.
 */
export const registryLabel = (
  labels: Record<string, string>,
  key: string,
  subject: string,
): string => {
  const label = labels[key];
  if (label) return label;

  reportStatsContractBreach(
    `Nieznana ${subject}: "${key}". Dopisz ją do rejestru etykiet.`,
  );
  return key;
};
